import React from "react"

import { useApiContext } from "~/api"
import { Layout } from "~/components/Layout/Layout"
import { Materials } from "~/views/press/components/Materials/Materials"

import { List } from "./components/List/List"

const Documents: React.FC = () => {
  const { name } = useApiContext("/documents/elements")

  return (
    <Layout headerTheme="onLight" title={name}>
      <List />
      {name === "Корпоративные документы" && <Materials />}
    </Layout>
  )
}

export default Documents
